/* 
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview require a script
 */
(function ($g) {
    var LOADING = {};
    var LOADED = {};
    var ERROR = {};
    
    var scripts={};

    $g.require = function (src, callback) {
        return new Promise(function(accept, reject) {
            var e = scripts[src]||{};
            scripts[src] = e;
            if (e.state===LOADED) {
                if (callback) {//Do not reload
                    callback();
                }
                accept();
                return;
            }
            e.state = LOADING;
            var t, r, d = document, s = d.createElement('script');
            s.src = src;
            s.async = true;
            s.onload = function () {
                if (!r) {
                    e.state = LOADED;
                    r = true;
                    if (callback) {
                        callback();
                    }
                }
                accept();
            };
            s.onerror = function (e) {
                if (e.state !== LOADED) {
                    e.state = ERROR;
                    $g.error("Impossible de charger " + src, e);                
                }
                reject(e);
            };
            t = d.getElementsByTagName('script')[0];
            t.parentNode.insertBefore(s, t);            
        });
    };
})(_P);